import React          from 'react';
import * as PropTypes from 'prop-types';

import BaseTabsWithDropDown from './base/BaseTabsWithDropDown';

export const RenderTabsWithDropdown = (props) => {
  return (<BaseTabsWithDropDown {...props} className={'basic-tabs withDropDown'} />);
};

RenderTabsWithDropdown.defaultProps = {
  active: 0,
};

RenderTabsWithDropdown.propTypes = {
  active:    PropTypes.number,
  changeTab: PropTypes.func.isRequired,
  children:  PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  nav:       PropTypes.array.isRequired,
  button:    PropTypes.object,
  dropdown:  PropTypes.shape({
    selected:         PropTypes.number,
    options:          PropTypes.array.isRequired,
    valueKey:         PropTypes.string,
    labelKey:         PropTypes.string,
    onChangeCallback: PropTypes.func,
  }).isRequired,
};